// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28759":"1b37925c","74326":"6ef4403f","93406":"439d819e"}[chunkId] + ".chunk.css";
};